"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var isInBrowser_1 = require("./utils/isInBrowser");
var logger_1 = __importDefault(require("./logger"));
var BaseClient = (function () {
    function BaseClient() {
        var _this = this;
        this.isInitialized = false;
        this.isMetricEmpty = function () { return !_this.metricCollector || _this.metricCollector.isEmpty(); };
        this.flush = function () {
            if (!_this.metricCollector || !_this.networkHandler || _this.metricCollector.isEmpty()) {
                return Promise.resolve();
            }
            logger_1["default"].log('flushing metrics', _this.metricCollector.metrics);
            var binaryPayload = _this.metricCollector.getPayload();
            _this.metricCollector.clearMetrics();
            return _this.networkHandler.sendRequest(binaryPayload);
        };
    }
    BaseClient.prototype.initialize = function (props) {
        var _a = props.debugMode, debugMode = _a === void 0 ? false : _a, _b = props.logTimeInterval, logTimeInterval = _b === void 0 ? 5 * 1000 : _b, _c = props.onIncrement, onIncrement = _c === void 0 ? function (v) { return [v]; } : _c, _d = props.onAddHistogram, onAddHistogram = _d === void 0 ? function (v) { return [v]; } : _d, _e = props.onAddTimer, onAddTimer = _e === void 0 ? function (v) { return [v]; } : _e;
        logger_1["default"].setDebugMode(debugMode);
        this.networkHandler = props.networkHandler;
        this.metricCollector = this.networkHandler.config.collector;
        this.onIncrement = onIncrement;
        this.onAddHistogram = onAddHistogram;
        this.onAddTimer = onAddTimer;
        this.timerId = setInterval(this.flush, logTimeInterval);
        if (isInBrowser_1.isInWindow()) {
            window.addEventListener('beforeunload', this.flush);
        }
        this.isInitialized = true;
        logger_1["default"].log('initializing SDK with config', props);
    };
    BaseClient.prototype.destroy = function () {
        var _a;
        logger_1["default"].log('destroying SDK.');
        if (this.timerId) {
            clearInterval(this.timerId);
        }
        if (this.heartBeatId) {
            clearInterval(this.heartBeatId);
        }
        this.isInitialized = false;
        (_a = this.metricCollector) === null || _a === void 0 ? void 0 : _a.clearMetrics();
        if (isInBrowser_1.isInWindow()) {
            window.removeEventListener('beforeunload', this.flush);
        }
    };
    BaseClient.prototype.isReady = function () {
        return this.isInitialized;
    };
    BaseClient.prototype.increment = function (metric) {
        var e_1, _a;
        if (!this.isInitialized || !this.metricCollector) {
            return;
        }
        try {
            for (var _b = __values(this.onIncrement(metric)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mappedMetric = _c.value;
                var metricsName = mappedMetric.metricsName, dimensions = mappedMetric.dimensions, _d = mappedMetric.value, value = _d === void 0 ? 1 : _d;
                if (!Number.isInteger(value)) {
                    throw new Error('value must be an integer in increment.');
                }
                this.metricCollector.increment({ metricsName: metricsName, dimensions: dimensions, value: value });
                logger_1["default"].log("increment counter " + metricsName + " with dimension ", dimensions, ' with value ', value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    BaseClient.prototype.addHistogram = function (metric) {
        var e_2, _a;
        if (!this.isInitialized || !this.metricCollector) {
            return;
        }
        try {
            for (var _b = __values(this.onAddHistogram(metric)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mappedMetric = _c.value;
                var metricsName = mappedMetric.metricsName, dimensions = mappedMetric.dimensions, value = mappedMetric.value;
                this.metricCollector.addHistogram({ metricsName: metricsName, dimensions: dimensions, value: value });
                logger_1["default"].log("addHistogram level " + metricsName + " with dimension ", dimensions, ' with value ', value);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    BaseClient.prototype.addTimer = function (metric) {
        var e_3, _a;
        if (!this.isInitialized || !this.metricCollector) {
            return;
        }
        try {
            for (var _b = __values(this.onAddTimer(metric)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mappedMetric = _c.value;
                var metricsName = mappedMetric.metricsName, dimensions = mappedMetric.dimensions, milliSec = mappedMetric.milliSec;
                var roundedMilliSec = Math.round(milliSec);
                this.metricCollector.addTimer({ metricsName: metricsName, dimensions: dimensions, milliSec: roundedMilliSec });
                logger_1["default"].log("addTimer timer " + metricsName + " with dimension ", dimensions, ' with milliSec ', roundedMilliSec);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    BaseClient.prototype.getCollectedMetrics = function () {
        var _a;
        return (_a = this.metricCollector) === null || _a === void 0 ? void 0 : _a.metrics;
    };
    return BaseClient;
}());
exports["default"] = BaseClient;
//# sourceMappingURL=BaseClient.js.map